import * as React from "react";

export interface HomeProps {}

const Home: React.FC<HomeProps> = props => {
  const barHeight = 445;
  const bottomAdjustment = -2;
  const skyHeight = window.innerHeight - barHeight + 2;

  return (
    <div>
      <section className="row">
        <div
          className="col-10 lead"
          style={{
            color: "white",
            fontSize: "2rem",
            fontFamily: "Gill Sans",
            left: 15,
            fontWeight: 100
          }}
        >
          The Highest Hilltop Bar of Koh Phangan
        </div>
      </section>
      <div
        style={{
          zIndex: -1,
          width: "100%",
          height: `${skyHeight}px`,
          position: "fixed",
          backgroundImage: "url('img/sky.png')",
          backgroundRepeat: "no-repeat",
          backgroundSize: "100% 100%",
          margin: "0",
          padding: "0",
          top: "0",
          left: "0"
        }}
      ></div>
      <div
        style={{
          zIndex: -1,
          width: "100%",
          height: `${barHeight}px`,
          position: "fixed",
          backgroundImage: "url('img/bar.png')",
          backgroundRepeat: "no-repeat",
          margin: "0",
          padding: "0",
          bottom: `${bottomAdjustment}px`,
          left: "0"
        }}
      ></div>
    </div>
  );
};

export default Home;
